import './Main.css'

import React from 'react'
import DatePicker from 'react-datepicker'
import { useWizard } from '@/common/wizard/wizard'
import { useAppContext } from '@/context/app'
import { canSelectRankingMachines, WizardData } from './Model'
import { MachineRankingExports } from './Exports'
import { getReportsFromDay } from '@/common/time'
import { ReportsFromDayNotice } from '@/components/reports/ReportsFromDayNotice'

export const MachinesReportWizardStep1 = () => {
  const { session, translates } = useAppContext()
  const { wizardData, updateWizardData, nextStep } = useWizard<WizardData>()
  const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));

  // @ts-ignore: Unreachable code error
  const ReactDatePicker = DatePicker.default ?? DatePicker;
  /* tslint:enable */

  if (translates === undefined || wizardData === undefined) {
    return <div className='spinner'></div>
  }

  return <>
    <div className='ranking-dates'>
      <h3>{translates.for('report.machinesranking.wizard.title')}</h3>
      <ReportsFromDayNotice />

      <form className="main-form" onSubmit={(e) => {
        e.preventDefault()
        nextStep()
      }}>

        <div className="form-field">
          <label htmlFor="from-date">{translates.for('report.machinesranking.wizard.from')}:</label>
          <ReactDatePicker
            id="from-date"
            name="from"
            selected={wizardData.from ? new Date(wizardData.from) : null}
            onChange={(date: Date | string) => {
              date = new Date(date)
              if (wizardData.to < date) {
                return
              }
              updateWizardData({
                ...wizardData,
                from: date || wizardData.from
              })
            }}
            // showTimeSelect={true}
            // timeIntervals={15}
            // timeFormat="HH:mm"
            // dateFormat="yyyy-MM-dd HH:mm"
            dateFormat="yyyy-MM-dd"
            minDate={getReportsFromDay() ?? undefined}
            maxDate={wizardData.to || yesterday}
            // placeholderText="Select start date and time"
            className="border rounded p-2"
            portalId="tooltip-wrap"
          />
        </div>

        {/* To Date */}
        <div className="form-field">
          <label htmlFor="to-date">{translates.for('report.machinesranking.wizard.to')}:</label>
          <ReactDatePicker
            id="to-date"
            name="to"
            selected={wizardData.to ? new Date(wizardData.to) : null}
            onChange={(date: Date | string) => {
              date = new Date(date)
              if (wizardData.from > date) {
                return
              }
              updateWizardData({
                ...wizardData,
                to: date || wizardData.to
              })
            }}
            // showTimeSelect
            // timeIntervals={15}
            // timeFormat="HH:mm"
            dateFormat="yyyy-MM-dd"
            placeholderText=""
            minDate={wizardData.from || undefined}
            maxDate={yesterday}
            className="border rounded p-2"
            portalId="tooltip-wrap"
          />
        </div>

        {canSelectRankingMachines(session?.user.role) && <div className='form-field'>
          <label htmlFor='ranking-select-machines' className='ranking-selection-toggle'>
            <input id='ranking-select-machines' type='checkbox' checked={wizardData.selectMachines}
              aria-label={translates.for('report.machinesranking.selection.title')} aria-describedby='ranking-selection-toggle-hint'
              onChange={e => updateWizardData({ selectMachines: e.target.checked })} />
            <span><strong>{translates.for('report.machinesranking.selection.title')}</strong>
              <span id='ranking-selection-toggle-hint' className='ranking-selection-toggle-hint'>{translates.for('report.machinesranking.selection.optional_hint')}</span>
            </span>
          </label>
        </div>}
        <div className='right-btns'>
          <button type='submit' className='btn btn-next'>{translates.for('report.machinesranking.wizard.next')}</button>
          {!wizardData.selectMachines && <MachineRankingExports />}
        </div>
      </form>
    </div>
  </>
}
